// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/icons/icons.less
// module id = 3636
// module chunks = 0